import 'css-chunksrc/client/pages/listPage/timestamp/styles.scss';export default {
  "timestamp": "_timestamp_1lavs_1",
  "dates": "_dates_1lavs_6",
  "row": "_row_1lavs_10",
  "date": "_date_1lavs_6",
  "redirectionsMenu": "_redirectionsMenu_1lavs_24"
};